import { useBackgroundAudioPlayerStore } from '@/shared/components/players/BackgroundAudioPlayer/store.ts';
import { useVoiceoverStore } from '@/shared/components/players/VoiceoverAudioPlayer/store.ts';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { storeToRefs } from 'pinia';

export const useAudioAutoEnable = () => {
  const backgroundAudioPlayerStore = useBackgroundAudioPlayerStore();

  const { getPlayer } = backgroundAudioPlayerStore;

  const { soundEnabled } = storeToRefs(backgroundAudioPlayerStore);
  const { voiceoverEnabled } = storeToRefs(useVoiceoverStore());

  const enableSound = () => {
    soundEnabled.value = true;

    getPlayer().unmute();
    getPlayer().play();
  };

  const enableVoiceover = () => {
    voiceoverEnabled.value = true;
  };

  const enableAudio = async () => {
    // On native, audio is auto-enabled via store initialization
    if (Capacitor.isNativePlatform()) {
      return;
    }

    // Do not allow enabling audio when app is not active
    if (!(await App.getState()).isActive) {
      return;
    }

    if (!localStorage.getItem('sound-enabled') || JSON.parse(localStorage.getItem('sound-enabled')!)) {
      enableSound();
    }

    if (!localStorage.getItem('voiceover-enabled') || JSON.parse(localStorage.getItem('voiceover-enabled')!)) {
      enableVoiceover();
    }
  };

  return {
    enableAudio,
  };
};
